// Preview-parametre (?preview=superadmin m.fl.) findes kun i udvikling og test. I produktion
// ignoreres de helt, så de hverken viser admin-flader, mock-data eller springer 2FA over.
function search(): string {
  if (!import.meta.env.DEV || typeof window === 'undefined') return '';
  return window.location.search;
}

export function previewParam(): string {
  return new URLSearchParams(search()).get('preview') || '';
}

export function isPreviewAdminMode(): boolean {
  return ['superadmin', 'admin'].includes(previewParam());
}

export function isPreviewProMode(): boolean {
  return ['pro', 'biotope', 'biotopplan', 'advisor'].includes(previewParam());
}

export function isPreviewOrTestMode(): boolean {
  const s = search();
  return s.includes('preview') || s.includes('test');
}
